<template>
	<section>
		<div v-if="!isDetailRoute">
			<header-page
				name="promotions"
				:title="$route.meta.title"
			/>
			
			<div class="px-5 mt-4">
				<app-table 
					class="my-5 is-not-selectable pb-4" 
					name="promotions" 
					:columns="columns" 
					:current-page="currentPage"
					:rows="rows" 
					:last-page="lastPage" 
					@on-search-event="onSearch" 
					@on-page="changePage"
				>
					<template slot="rows" slot-scope="props">
						<td class="is-not-selectable" v-show="showRow(columns, 1)">
							{{ props.row.title }}
						</td>
						<td v-show="showRow(columns, 2)">
							{{ props.row.description || 'Sin descripción' }} 
						</td>
						<td v-show="showRow(columns, 3)">
							<v-chip :color="props.row.isActive ? 'green' : 'grey'" text-color="white" small>
								{{ props.row.isActive ? 'Activo' : 'Inactivo' }}
							</v-chip>
						</td>
						<td v-show="showRow(columns, 4)" class="d-flex align-center">
							<app-tooltip-button
								color="blue"
								icon="collections"
								text="Banners / Detalles"
								@click-icon="details(props.row)"
							/>
							<app-tooltip-button
								color="blue"
								icon="edit"
								text="Editar"
								@click-icon="edit(props.row)"
							/>
							<app-tooltip-button
								color="red"
								icon="delete"
								text="Eliminar"
								@click-icon="openModalConfirmation(props.row)"
							/>
							<v-tooltip top>
								<v-switch
									slot="activator"
									color="green"
									class="mt-0 ml-2"
									hide-details
									v-model="props.row.isActive"
									@change="toggleStatus(props.row)"
								></v-switch>
								<span class="text-center">{{ props.row.isActive ? 'Desactivar' : 'Activar' }} promoción</span>
							</v-tooltip>
						</td>
					</template>
				</app-table>
			</div>
			
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
		</div>
		
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
		<router-view></router-view>
	</section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appConfirmationModal from '@/components/shared/app-confirmation-modal';

function openModal() {
	this.goTo('page-new-promotion');
}

function edit({ id }) {
	this.goTo('page-edit-promotion', { params: { id } });
}

function details({ id }) {
	this.goTo('page-promotion-details', { params: { id, codeProject: this.codeProject } });
}

async function confirm() {
	try {
		const headers = { Accept: `${process.env.ACCEPT_SERVICE_V2}` };
		await this.$http.delete(`promotion/${this.modalConfirmation.selectedRow.id}`, { headers });
		this.showNotification('La promoción se eliminó correctamente');
		this.cancelModalConfirmation();
		this.loadData();
	} catch (error) {
		this.showError();
	}
}

async function loadData() {
	try {
		const params = { ...this.params };
		const headers = { Accept: `${process.env.ACCEPT_SERVICE_V2}` };
		const response = await this.$http.get('promotion', { params, headers });
		// Validamos según la estructura que definiste previamente[cite: 4]
		this.rows = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
	this.loadData();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}

function created() {
	this.loadData();
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'PROMO',
				text: 'Agregar Promoción',
				img: '',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Título', checked: true, visible: true },
			{ id: 2, name: 'Descripción', checked: true, visible: true },
			{ id: 3, name: 'Estado', checked: true, visible: true },
			{ id: 4, name: '', checked: true, visible: true, flagVisible: true },
		],
		currentPage: 1,
		lastPage: 0,
		rows: [],
		loading: false,
		params: {
			page: 1,
			codeProject: this.codeProject,
		},
	};
}

export default {
	name: 'page-promotions',
	data,
	created,
	components: {
		appTooltipButton,
		quickActions,
		appConfirmationModal,
	},
	computed: {
		isDetailRoute() {
			// Evalúa si estamos en la ruta hija de detalles[cite: 4]
			return this.$route.name && this.$route.name.includes('details');
		},
	},
	methods: {
		openModal,
		edit,
		loadData,
		changePage,
		onSearch,
		details,
		confirm,
		async toggleStatus(row) {
			const { isActive, id, title, description } = row;
			const message = isActive ? 'activó' : 'desactivó';
			const body = {
				isActive,
				title,
				description
			};
			const headers = { Accept: `${process.env.ACCEPT_SERVICE_V2}` };
			try {
				await this.$http.patch(`promotion/${id}`, body, { headers });
				this.showNotification(`Se ${message} la promoción`);
			} catch (error) {
				this.showNotification('No se pudo cambiar el estado de la promoción', 'error');
			}
		},
	},
	props: {
		codeProject: {
			type: String,
		},
	},
	watch: {
		$route(newVal) {
			if (newVal && newVal.name === 'page-promotions') {
				this.loadData();
			}
		},
		params: {
			handler(newVal) {
				if (newVal) this.loadData();
			},
			deep: true
		}
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/promotions/page-promotions.vue